/* global require module */
'use strict';

module.exports = require('translitit-engine')({
    'зг' : 'zgh',
    'Зг' : 'Zgh',
    'А':'A',
    'а':'a',
    'Б':'B',
    'б':'b',
    'В':'V',
    'в':'v',
    'Г':'G',
    'г':'g',
    'Ґ':'G',
    'ґ':'g',
    'Д':'D',
    'д':'d',
    'Е':'E',
    'е':'e',
    'Ё':'E',
    'ё':'e',
    'Є':'Ye',
    'є':'ie',
    'Ж':'Zh',
    'ж':'zh',
    'З':'Z',
    'з':'z',
    'И':'I',
    'и':'i',
    'І':'I',
    'і':'i',
    'Ї':'Yi',
    'ї':'i',
    'Й':'Y',
    'й':'i',
    'К':'K',
    'к':'k',
    'Л':'L',
    'л':'l',
    'М':'M',
    'м':'m',
    'Н':'N',
    'н':'n',
    'О':'O',
    'о':'o',
    'П':'P',
    'п':'p',
    'Р':'R',
    'р':'r',
    'С':'S',
    'с':'s',
    'Т':'T',
    'т':'t',
    'У':'U',
    'у':'u',
    'Ф':'F',
    'ф':'f',
    'Х':'Kh',
    'х':'kh',
    'Ц':'Ts',
    'ц':'ts',
    'Ч':'Ch',
    'ч':'ch',
    'Ш':'Sh',
    'ш':'sh',
    'Щ':'Shch',
    'щ':'shch',
    'Ы':'Y',
    'ы':'y',
    'Э':'E',
    'э':'e',
    'Ю':'Yu',
    'ю':'iu',
    'Я':'Ya',
    'я':'ia',
    'Ь': '',
    'ь': '',
    'Ъ': '',
    'ъ': '',
    '\'': ''
});
